export const getAnalyticsDashboardApi = async (axiosPrivate) => {
	const response = await axiosPrivate.get("/admin/analytics/dashboard");
	return response.data;
};
